import $ from 'jquery';
import {Swiper, Navigation, Pagination} from 'swiper/js/swiper.esm.js';
Swiper.use([Navigation, Pagination]);


$('.swiper-image-carousel').each(function (){
	const $self = $(this);
	const imageCarousel = new Swiper($self[0], {
		loop: true,
		autoHeight: false,
		slidesPerView: 1,
		spaceBetween: 0,
		watchOverflow: true,
		pagination: {
			el: $self.find('.swiper-pagination')[0],
			type: "fraction",
		},
		navigation: {
			prevEl: $self.find('.image-carousel-swiper-buttons .swiper-button-prev')[0],
			nextEl: $self.find('.image-carousel-swiper-buttons .swiper-button-next')[0],
		}
	});
});
